<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addCertification, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="certification" :title="$t('front.import_modal', {model: $t('strings.certification')})")
    modal-certifications(:newRecord='newRecord', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.certifications') }}:
            span {{ $t('strings.description', {attribute: $t('strings.certifications')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected"  max-height="350px" :data="certifications")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                div
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('certifications.'+ item)")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('certifications.date')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.date")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                          vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(url="customers" columns="tradename,etc" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                              vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in certificationsCatalog.customers")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('certifications.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'hp_profile'") {{ `${data[indextr]['profile']['name']} ${data[indextr]['profile']['last_name']}` }}
                  slot(v-if="column == 'curp'") {{ `${data[indextr]['profile']['curp']}` }}
                  vm-status-indicator(v-if="column == 'status'" :color="colorStatus(data[indextr]['status'])") {{textStatus(data[indextr]['status'])}}
                  slot(v-if="column == 'certified_at'") {{data[indextr]['certified_at']}}
                  slot(v-if="column == 'account_status_file'")
                    vm-button(type="flat" size="large" vm-type="flex" vm-align="right" icon="eye-outline" color="primary" @click="fileView(data[indextr]['account_status_file'])") Visualizar
                  slot(v-if="column == 'identification_file'")
                    vm-button(type="flat" size="large" vm-type="flex" vm-align="right" icon="eye-outline" color="primary" @click="fileView(data[indextr]['identification_file'])") Visualizar
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click v-if="data[indextr]['status'] == 'in_progress'")
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="setActionCertification(data[indextr], 'certified')")
                      vm-icon(icon="award")
                      slot &nbsp;{{ $t('strings.certify') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="setActionCertification(data[indextr], 'rejected')")
                      vm-icon(icon="backspace")
                      slot &nbsp;{{ $t('strings.reject') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ModalCertifications from '@/components/modals/ModalCertifications.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Certifications')

export default {
  name: 'Certifications',
  components: {
    ModalCertifications,
    ModalImport
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    newRecord: {},
    selected: [],
    columns: [
      'hp_profile',
      'curp',
      'account_status_file',
      'identification_file',
      'status',
      'certified_at'
    ],
    columnsOrderBy: [
      // Nota solo si las columnas son atributos
      'hp_profile_id',
      'status',
      'account_status_file',
      'identification_file',
      'certified_at'
    ],
    status: [
      // Agregar los estatus si maneja
      {
        text: 'En proceso',
        value: 'in_progress',
        color: 'secondary'
      },
      {
        text: 'Certificado',
        value: 'certified',
        color: 'primary'
      },
      {
        text: 'Rechazado',
        value: 'rejected',
        color: 'warning'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        // Agregar las columnas que se filtraran en el buscador
        // name_last_name: [
        //  'name',
        //  'last_name'
        // ],
        certification_status: {
          name: ''
        },
        profile: {
          name: ''
        },
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
        status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at:
        date: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  computed: {
    ...mapGetters([
      'certifications',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('certifications.' + column)}` : `${str} ${t.$t('certifications.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.certification'), columns: concatColumns, column: this.$t('certifications.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getCertifications(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getCertifications(this.currentPage)
    }
  },
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    await this.getCertifications(1)
  },
  methods: {
    ...mapActions([
      'deleteCertification',
      'deleteCertifications',
      'loadCertifications',
      'loadCatalog',
      'actionCertification',
      'setModalImportVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'clearFilter',
      'seeFile'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    textStatus (code) {
      return this.status.find(e => e.value === code)['text']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.certifications.findIndex(u => u.id === this.selected[0].id)
      this.editCertification(this.selected[0], idx)
    },
    addCertification () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    editCertification (certification, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.newRecord = { ...certification }
    },
    async deleteCertificationConfirm (certification) {
      let t = this
      this.auxDeleteCertification = () => {
        t.deleteCertification(certification).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.certification'), attribute: this.$t(certification.folio) }),
        accept: this.auxDeleteCertification
      })
    },
    async deleteCertificationsConfirm () {
      let t = this
      let certificationsMany = parseDeleteMany(this.selected, 'folio')
      this.auxDeleteCertification = () => {
        t.deleteCertifications(certificationsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.certification'), attribute: certificationsMany.values }),
        accept: this.auxDeleteCertification
      })
    },
    async setActionCertification (record, action) {
      record.id && this.actionCertification({ id: record.id, action })
    },
    async fileView (file) {
      window.open(file)
    },
    async getCertifications (page) {
      let t = this
      this.loadCertifications({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let certification = this.certifications.filter(certification => certification.id === parseInt(index))[0]
      certification && this.editCertification(certification, index)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      this.filters.betweenDates.date = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  float: left;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
